/* Everdog theme behaviours. Plain ES2017, no dependencies. Works alongside Horizon's own components. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncements() {
    $$('.ed-announce').forEach(function (bar) {
      if (bar.dataset.edInit) return;
      bar.dataset.edInit = '1';
      var items = $$('.ed-announce__item', bar);
      if (items.length < 2) return;
      var i = 0, speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Header: sticky shadow, mobile drawer, height variable ---------- */
  function initHeader() {
    var header = $('.ed-header');
    if (!header) return;
    var setHeight = function () {
      document.documentElement.style.setProperty('--ed-header-height', header.offsetHeight + 'px');
      document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
    };
    setHeight();
    window.addEventListener('resize', setHeight);
    var onScroll = function () {
      var wrap = document.querySelector('.page-wrapper');
      var y = Math.max(window.scrollY, wrap ? wrap.scrollTop : 0);
      header.classList.toggle('is-stuck', y > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    var drawer = $('.ed-drawer');
    if (drawer) {
      var open = function () { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
      var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
      $$('[data-ed-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-ed-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ---------- Generic horizontal carousel (scroll-snap track + arrows + progress bar) ---------- */
  function initCarousels() {
    $$('.ed-carousel').forEach(function (c) {
      if (c.dataset.edInit) return;
      c.dataset.edInit = '1';
      var track = $('.ed-carousel__track', c);
      if (!track) return;
      var prev = $('.ed-carousel__arrow--prev', c), next = $('.ed-carousel__arrow--next', c), thumb = $('.ed-carousel__thumb', c);
      var step = function () { var first = track.firstElementChild; return first ? first.getBoundingClientRect().width + 20 : 300; };
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (thumb) {
          var ratio = track.clientWidth / track.scrollWidth;
          var w = Math.max(ratio * 100, 12);
          thumb.style.width = w + '%';
          thumb.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - w) : 0) + '%';
        }
        if (c.classList.contains('ed-carousel--center')) {
          var mid = track.scrollLeft + track.clientWidth / 2, best = null, bd = 1e9;
          $$('.ed-carousel__track > *', c).forEach(function (el) {
            var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - mid);
            if (d < bd) { bd = d; best = el; }
            el.classList.remove('is-center');
          });
          if (best) best.classList.add('is-center');
        }
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (c.classList.contains('ed-carousel--center')) {
        track.scrollLeft = (track.scrollWidth - track.clientWidth) / 2;
      }
      update();
    });
  }

  /* ---------- Tab groups (ingredients directory categories) ---------- */
  function initTabs() {
    $$('[data-ed-tabs]').forEach(function (wrap) {
      if (wrap.dataset.edInit) return;
      wrap.dataset.edInit = '1';
      var tabs = $$('[data-ed-tab]', wrap), items = $$('[data-ed-tab-item]', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var wasActive = tab.classList.contains('is-active');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          var key = wasActive ? '' : tab.dataset.edTab;
          if (!wasActive) tab.classList.add('is-active');
          items.forEach(function (it) {
            var cats = (it.dataset.edTabItem || '').toLowerCase();
            it.hidden = key ? cats.indexOf(key.toLowerCase()) === -1 : false;
          });
        });
      });
    });
  }

  /* ---------- Spotlight switchers (team bios, vet quotes) ---------- */
  function initSwitchers() {
    $$('[data-ed-switch]').forEach(function (wrap) {
      if (wrap.dataset.edInit) return;
      wrap.dataset.edInit = '1';
      var btns = $$('[data-ed-switch-to]', wrap), panels = $$('[data-ed-switch-panel]', wrap);
      var show = function (key) {
        btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.edSwitchTo === key); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.edSwitchPanel === key); });
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.edSwitchTo); }); });
      var auto = parseInt(wrap.dataset.edSwitch || '0', 10);
      if (auto > 0 && btns.length > 1) {
        var i = 0;
        setInterval(function () { i = (i + 1) % btns.length; show(btns[i].dataset.edSwitchTo); }, auto * 1000);
      }
    });
  }

  /* ---------- Product page ---------- */
  function money(cents, format) {
    var v = (Math.round(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, whole + '.' + parts[1]);
  }
  function selectOne(list, el) {
    list.forEach(function (x) {
      var on = x === el;
      x.classList.toggle('is-selected', on);
      if (x.getAttribute('role') === 'radio') x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function initProduct() {
    $$('.ed-pdp').forEach(function (pdp) {
      if (pdp.dataset.edInit) return;
      pdp.dataset.edInit = '1';

      /* Gallery */
      var slides = $$('.ed-pdp__slide', pdp), thumbs = $$('.ed-pdp__thumb', pdp);
      var showSlide = function (i) {
        slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        thumbs.forEach(function (x, j) { x.classList.toggle('is-active', i === j); });
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });

      /* Data */
      var dataEl = $('[data-ed-product-json]', pdp);
      var product = null;
      try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { product = null; }
      var form = $('form[data-type="add-to-cart-form"]', pdp);
      var idInput = form ? $('input[name="id"]', form) : null;
      var planInput = form ? $('input[name="selling_plan"]', form) : null;
      var qtyHidden = $('[data-ed-qty-input]', pdp);
      var stepInput = $('.ed-qty input', pdp);
      var moneyFormat = pdp.dataset.moneyFormat || '${{amount}}';

      /* Purchase UI */
      var bb = $('[data-ed-bb]', pdp);
      var live = !!bb && bb.dataset.live === 'true';
      var stackSub = !bb || bb.dataset.stackSub !== 'false';
      var unitLabel = bb ? bb.dataset.unit || '' : '';
      var modeBtns = $$('[data-ed-mode]', pdp);
      var tierBtns = $$('[data-ed-tier]', pdp);
      var planSel = $('[data-ed-plan-select]', pdp);
      var selMode = modeBtns.filter(function (b) { return b.classList.contains('is-selected'); })[0];
      var mode = selMode ? selMode.dataset.edMode : 'once';
      var tier = tierBtns.filter(function (b) { return b.classList.contains('is-selected'); })[0] || tierBtns[0] || null;

      function currentVariant() {
        if (!product) return null;
        var id = idInput ? parseInt(idInput.value, 10) : 0;
        for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
        return product.variants[0];
      }
      function planId() { return planSel ? planSel.value : (bb && bb.dataset.plan) || ''; }
      function allocationPrice(v, pid) {
        pid = parseInt(pid, 10);
        var a = (v.selling_plan_allocations || []).filter(function (x) { return x.selling_plan_id === pid; })[0];
        return a ? a.price : null;
      }
      function unitPrice(v, m, tierPlan) {
        if (m === 'sub') {
          var p = tierPlan ? allocationPrice(v, tierPlan) : null;
          if (p === null) p = allocationPrice(v, planId());
          if (p !== null) return p;
        }
        return v.price;
      }
      function lineTotal(v, m, qty, pct, tierPlan, tierSubPct) {
        var subPctNative = parseFloat(tierSubPct) || 0;
        if (m === 'sub' && subPctNative > 0) return Math.round(v.price * qty * (100 - subPctNative) / 100);
        var ownPlan = m === 'sub' && tierPlan && allocationPrice(v, tierPlan) !== null;
        var p = !ownPlan && live && pct > 0 && (m !== 'sub' || stackSub) ? pct : 0;
        return Math.round(unitPrice(v, m, ownPlan ? tierPlan : '') * qty * (100 - p) / 100);
      }
      function render() {
        var v = currentVariant();
        if (!v) return;
        tierBtns.forEach(function (b) {
          var q = parseInt(b.dataset.qty, 10) || 1, pct = parseInt(b.dataset.pct, 10) || 0;
          var t = lineTotal(v, mode, q, pct, b.dataset.plan, b.dataset.subPct), c = v.price * q;
          var pe = $('[data-tier-price]', b), ce = $('[data-tier-compare]', b), ee = $('[data-tier-each]', b), se = $('[data-tier-save]', b);
          if (pe) pe.textContent = money(t, moneyFormat);
          if (ce) { ce.textContent = money(c, moneyFormat); ce.hidden = !(c > t); }
          if (se) {
            var savePct = c > t ? Math.round((c - t) * 100 / c) : 0;
            se.textContent = ((bb && bb.dataset.saveFormat) || 'Save {pct}%').split('{pct}').join(savePct);
            se.hidden = savePct <= 0;
          }
          if (ee) {
            var eachFmt = (bb && bb.dataset.eachFormat) || '{price} / {unit}';
            ee.textContent = unitLabel ? eachFmt.split('{price}').join(money(t / q, moneyFormat)).split('{unit}').join(unitLabel) : money(t / q, moneyFormat);
          }
        });
        var qty = tier ? (parseInt(tier.dataset.qty, 10) || 1) : (stepInput ? Math.max(1, parseInt(stepInput.value, 10) || 1) : 1);
        var pct = tier ? (parseInt(tier.dataset.pct, 10) || 0) : 0;
        if (qtyHidden) qtyHidden.value = qty;
        var tierPlan = tier && tier.dataset.plan && allocationPrice(v, tier.dataset.plan) !== null ? tier.dataset.plan : '';
        var tierSubPct = tier ? tier.dataset.subPct : '';
        var total = lineTotal(v, mode, qty, pct, tierPlan, tierSubPct);
        $$('[data-ed-atc-price]', pdp).forEach(function (el) { el.textContent = money(total, moneyFormat); });
        if (planInput) {
          var pid = mode === 'sub' ? (tierPlan || planId()) : '';
          planInput.value = pid;
          planInput.disabled = !pid;
        }
        /* "Subscribe & Save X%" follows the selected quantity's subscription saving */
        var modeSave = $('[data-ed-mode-save]', pdp);
        if (modeSave) {
          var full = v.price * qty, subTotal = lineTotal(v, 'sub', qty, pct, tierPlan, tierSubPct);
          var subPct = full > subTotal ? Math.round((full - subTotal) * 100 / full) : 0;
          if (subPct > 0) modeSave.textContent = modeSave.dataset.edModeSave.split('{pct}').join(subPct);
        }
        $$('[data-ed-sub-only]', pdp).forEach(function (el) { el.hidden = mode !== 'sub'; });
        $$('[data-ed-hide-on-sub]', pdp).forEach(function (el) { el.hidden = mode === 'sub'; });
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      }
      modeBtns.forEach(function (b) {
        b.addEventListener('click', function () { mode = b.dataset.edMode; selectOne(modeBtns, b); render(); });
      });
      tierBtns.forEach(function (b) {
        b.addEventListener('click', function () { tier = b; selectOne(tierBtns, b); render(); });
      });
      if (planSel) planSel.addEventListener('change', render);
      if (stepInput) {
        $$('.ed-qty button', pdp).forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(stepInput.value || '1', 10) || 1;
            v += b.dataset.dir === 'minus' ? -1 : 1;
            stepInput.value = Math.max(1, v);
            render();
          });
        });
        stepInput.addEventListener('change', render);
      }

      /* Variant option buttons (e.g. Flavor: Chicken / Beef, sizes) */
      var optionBtns = $$('[data-ed-option]', pdp);
      if (optionBtns.length && product) {
        var chosen = {};
        optionBtns.forEach(function (b) { if (b.classList.contains('is-selected')) chosen[b.dataset.edOption] = b.dataset.edValue; });
        var apply = function (pushUrl) {
          var match = product.variants.filter(function (v) {
            return v.options.every(function (val, idx) { return chosen[String(idx)] === undefined || chosen[String(idx)] === val; });
          })[0];
          if (match && idInput) {
            idInput.value = match.id;
            var btn = $('.ed-pdp__atc', pdp);
            if (btn) {
              btn.disabled = !match.available;
              var t = $('.ed-pdp__atc-text', btn);
              if (t) t.textContent = match.available ? (btn.dataset.addText || 'Add to Cart') : (btn.dataset.soldText || 'Sold out');
            }
            if (pushUrl && window.history && history.replaceState) {
              try { var u = new URL(window.location.href); u.searchParams.set('variant', match.id); history.replaceState(null, '', u.toString()); } catch (e) {}
            }
          }
          var chosenVals = Object.keys(chosen).map(function (k) { return String(chosen[k]).toLowerCase(); });
          $$('[data-ed-selected-label]', pdp).forEach(function (el) { var v = chosen[el.dataset.edSelectedLabel]; if (v) el.textContent = v; });
          /* gallery: tagged photos show only for their value; untagged photos show always;
             a value with no tagged photos shows its placeholder slots (unless untagged photos exist) */
          var real = slides.filter(function (s) { return !s.dataset.edPlaceholder; });
          var anyTagged = real.some(function (s) { return s.dataset.edGroup; });
          var realForChosen = real.filter(function (s) { return s.dataset.edGroup && chosenVals.indexOf(s.dataset.edGroup) !== -1; });
          var untagged = real.filter(function (s) { return !s.dataset.edGroup; });
          if (slides.some(function (s) { return s.dataset.edGroup; })) {
            slides.forEach(function (s, i) {
              var g = s.dataset.edGroup, isPh = !!s.dataset.edPlaceholder, show;
              if (isPh) show = !!g && chosenVals.indexOf(g) !== -1 && realForChosen.length === 0 && (untagged.length === 0 || (!anyTagged && real.length === 0));
              else if (!g) show = true;
              else show = !anyTagged || chosenVals.indexOf(g) !== -1;
              s.hidden = !show;
              if (thumbs[i] && thumbs[i].parentElement) thumbs[i].parentElement.hidden = !show;
            });
            var activeVisible = slides.some(function (s) { return s.classList.contains('is-active') && !s.hidden; });
            if (!activeVisible) {
              var firstIdx = -1;
              slides.forEach(function (s, i) { if (firstIdx === -1 && !s.hidden) firstIdx = i; });
              if (firstIdx > -1) showSlide(firstIdx);
            }
          }
          $$('[data-ed-only]', pdp).forEach(function (el) { el.hidden = chosenVals.indexOf(String(el.dataset.edOnly).toLowerCase()) === -1; });
          render();
        };
        optionBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            chosen[b.dataset.edOption] = b.dataset.edValue;
            optionBtns.forEach(function (x) { if (x.dataset.edOption === b.dataset.edOption) x.classList.toggle('is-selected', x === b); });
            apply(true);
          });
        });
        apply(false);
      } else {
        render();
      }
    });
  }

  /* ---------- Lot number search placeholder (science page) ---------- */
  function initLotSearch() {
    $$('[data-ed-lot-form]').forEach(function (f) {
      if (f.dataset.edInit) return;
      f.dataset.edInit = '1';
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = $('[data-ed-lot-msg]', f.parentElement);
        if (msg) msg.hidden = false;
      });
    });
  }

  /* ---------- Video cards: click to play/pause ---------- */
  function initVideos() {
    $$('.ed-video').forEach(function (card) {
      if (card.dataset.edInit) return;
      card.dataset.edInit = '1';
      var v = $('video', card);
      if (!v) return;
      card.addEventListener('click', function () {
        if (v.paused) { v.play(); card.classList.add('is-playing'); } else { v.pause(); card.classList.remove('is-playing'); }
      });
      v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $$('[data-ed-sort]').forEach(function (sel) {
      if (sel.dataset.edInit) return;
      sel.dataset.edInit = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Blog list filter/search ---------- */
  function initBlogFilter() {
    $$('[data-ed-blog]').forEach(function (wrap) {
      if (wrap.dataset.edInit) return;
      wrap.dataset.edInit = '1';
      var cat = $('[data-ed-blog-cat]', wrap), q = $('[data-ed-blog-q]', wrap), cards = $$('[data-ed-article]', wrap), empty = $('[data-ed-blog-empty]', wrap);
      var run = function () {
        var c = cat ? cat.value.toLowerCase() : '', s = q ? q.value.toLowerCase().trim() : '', n = 0;
        cards.forEach(function (card) {
          var ok = (!c || (card.dataset.edArticle || '').toLowerCase().indexOf(c) !== -1) && (!s || card.textContent.toLowerCase().indexOf(s) !== -1);
          card.hidden = !ok; if (ok) n++;
        });
        if (empty) empty.hidden = n > 0;
      };
      if (cat) cat.addEventListener('change', run);
      if (q) q.addEventListener('input', run);
      run();
    });
  }

  /* ---------- Review wall: filters, sort, show more, read more, photo lightbox ---------- */
  function initReviews() {
    $$('[data-ed-reviews]').forEach(function (wrap) {
      if (wrap.dataset.edInit) return;
      wrap.dataset.edInit = '1';
      var grid = $('[data-ed-rv-grid]', wrap);
      if (!grid) return;
      var cards = $$('[data-ed-rv-card]', grid);
      var more = $('[data-ed-rv-more]', wrap), empty = $('[data-ed-rv-empty]', wrap), sortSel = $('[data-ed-rv-sort]', wrap);
      var filterBtns = $$('[data-ed-rv-filter]', wrap);
      var mq = window.matchMedia('(max-width: 767px)');
      var step = function () { return parseInt(mq.matches ? wrap.dataset.initialMobile : wrap.dataset.initial, 10) || 6; };
      var state = { filter: 'all', sort: 'featured', limit: step() };
      var num = function (v) { return parseInt(v, 10) || 0; };
      var matches = function (c) {
        if (state.filter === 'all') return true;
        if (state.filter === 'photos') return c.dataset.photos === '1';
        return c.dataset.rating === state.filter;
      };
      function checkClamp() {
        cards.forEach(function (c) {
          var body = $('[data-ed-rv-body]', c), btn = $('[data-ed-rv-expand]', c);
          if (c.hidden || !body || !btn || body.classList.contains('is-open')) return;
          btn.hidden = body.scrollHeight <= body.clientHeight + 2;
        });
      }
      function apply() {
        var list = cards.slice().sort(function (a, b) {
          var tie = num(a.dataset.order) - num(b.dataset.order);
          if (state.sort === 'high') return num(b.dataset.rating) - num(a.dataset.rating) || tie;
          if (state.sort === 'low') return num(a.dataset.rating) - num(b.dataset.rating) || tie;
          if (state.sort === 'photos') return num(b.dataset.photos) - num(a.dataset.photos) || tie;
          return tie;
        });
        var n = 0;
        list.forEach(function (c) {
          grid.appendChild(c);
          var ok = matches(c);
          if (ok) n++;
          c.hidden = !ok || n > state.limit;
        });
        if (more) more.hidden = n <= state.limit;
        if (empty) empty.hidden = n > 0;
        checkClamp();
      }
      cards.forEach(function (c) {
        var body = $('[data-ed-rv-body]', c), btn = $('[data-ed-rv-expand]', c);
        if (!body || !btn) return;
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('is-open');
          btn.textContent = open ? 'Show less' : 'Read more';
        });
      });
      filterBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.dataset.edRvFilter;
          state.filter = (state.filter === v && v !== 'all') ? 'all' : v;
          state.limit = step();
          filterBtns.forEach(function (x) {
            var on = x.dataset.edRvFilter === state.filter;
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
            x.classList.toggle('is-active', on);
          });
          apply();
        });
      });
      if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
      if (more) more.addEventListener('click', function () { state.limit += step(); apply(); });
      apply();
      window.addEventListener('load', checkClamp);

      /* Photo lightbox */
      var lb = $('[data-ed-rv-lb]', wrap);
      var photos = $$('[data-ed-rv-photo]', grid);
      var idx = 0;
      if (!lb || typeof lb.showModal !== 'function' || !photos.length) return;
      var img = $('[data-ed-rv-lb-img]', lb), box = $('[data-ed-rv-lb-review]', lb);
      var prev = $('[data-ed-rv-lb-prev]', lb), next = $('[data-ed-rv-lb-next]', lb);
      function show(i) {
        idx = (i + photos.length) % photos.length;
        var p = photos[idx], card = p.closest('[data-ed-rv-card]');
        img.src = p.dataset.full;
        img.alt = p.dataset.alt || '';
        box.innerHTML = '';
        ['.ed-rv__card-top', '.ed-rv__title', '.ed-rv__body', '.ed-rv__who', '.ed-rv__product'].forEach(function (sel) {
          var el = card && $(sel, card);
          if (!el) return;
          var copy = el.cloneNode(true);
          copy.removeAttribute('data-ed-rv-body');
          box.appendChild(copy);
        });
        prev.hidden = next.hidden = photos.length < 2;
      }
      function close() { if (lb.open) lb.close(); }
      lb.addEventListener('close', function () { document.documentElement.classList.remove('ed-rv-lock'); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      $('[data-ed-rv-lb-close]', lb).addEventListener('click', close);
      prev.addEventListener('click', function () { show(idx - 1); });
      next.addEventListener('click', function () { show(idx + 1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
      wrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ed-rv-open]');
        if (!t || lb.contains(t)) return;
        var id = t.dataset.edRvOpen, n = t.dataset.edRvIndex;
        var i = photos.findIndex(function (p) { return p.dataset.edRvOpen === id && p.dataset.edRvIndex === n; });
        if (i < 0) return;
        show(i);
        lb.showModal();
        document.documentElement.classList.add('ed-rv-lock');
      });
    });
  }

  /* Product page rating line: use the review wall's live average when reviews are published */
  function initReviewSummary() {
    var wall = $('[data-ed-reviews]');
    if (!wall) return;
    var count = parseInt(wall.dataset.count, 10) || 0, avg = parseFloat(wall.dataset.avg) || 0;
    if (!count) return;
    var star = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2.5 2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8L12 2.5Z"/></svg>';
    var five = star + star + star + star + star;
    var countText = count.toLocaleString('en-US');
    $$('[data-ed-rating-placeholder]').forEach(function (r) {
      var fmt = r.dataset.format || '{avg} ({count} {reviews})';
      var word = count === 1 ? (r.dataset.wordOne || 'review') : (r.dataset.wordMany || 'reviews');
      var text = fmt.split('{avg}').join(avg.toFixed(1)).split('{count}').join(countText).split('{reviews}').join(word);
      r.removeAttribute('data-ed-rating-placeholder');
      r.setAttribute('aria-label', 'Rated ' + avg.toFixed(1) + ' out of 5 from ' + countText + ' ' + word);
      r.innerHTML = '<a class="ed-pdp__rating-link" href="#reviews"><span class="ed-rv__stars" style="--rv-fill:' + Math.round(avg * 20) + '%"><span class="ed-rv__stars-base">' + five + '</span><span class="ed-rv__stars-fill">' + five + '</span></span><span class="ed-pdp__rating-count">' + text + '</span></a>';
    });
  }

  /* ---------- Offer countdown to a real end date (same clock for everyone) ---------- */
  function initCountdowns() {
    $$('[data-ed-countdown]').forEach(function (el) {
      if (el.dataset.edInit) return;
      el.dataset.edInit = '1';
      var end = parseInt(el.dataset.edCountdown, 10) * 1000;
      if (!end || isNaN(end)) return;
      var label = (el.dataset.text || 'Ends in').split('{time}').join('').trim();
      var units = (el.dataset.units || 'days,hrs,min,sec').split(',').map(function (u) { return u.trim(); });
      var esc = function (str) { return String(str).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timer, built = 0;
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          var box = el.closest('.ed-bb__offer-sub') || el.closest('.ed-bb__offer');
          if (box) box.classList.add('is-expired'); else el.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        var vals = d > 0 ? [String(d), pad(h), pad(m), pad(s)] : [pad(h), pad(m), pad(s)];
        var names = d > 0 ? units : units.slice(1);
        if (built !== vals.length) {
          el.innerHTML = (label ? '<span class="ed-cd__label">' + esc(label) + '</span>' : '') + vals.map(function (v, i) {
            return '<span class="ed-cd__seg"><b>' + v + '</b><small>' + esc(names[i] || '') + '</small></span>';
          }).join('<span class="ed-cd__sep" aria-hidden="true">:</span>');
          built = vals.length;
        } else {
          $$('.ed-cd__seg b', el).forEach(function (b, i) { b.textContent = vals[i]; });
        }
        el.hidden = false;
      }
      timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Same-day dispatch countdown: a daily clock to the store's real cutoff ---------- */
  function initShipTimers() {
    $$('[data-ed-ship]').forEach(function (el) {
      if (el.dataset.edInit) return;
      el.dataset.edInit = '1';
      var cut = (el.dataset.cutoff || '14:00').split(':');
      var H = parseInt(cut[0], 10), M = parseInt(cut[1] || '0', 10);
      if (isNaN(H) || isNaN(M) || H < 0 || H > 23 || M < 0 || M > 59) return;
      var names3 = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var days = (el.dataset.days || 'mon,tue,wed,thu,fri').toLowerCase().split(',').map(function (d) { return d.trim().slice(0, 3); });
      var ok = names3.map(function (n) { return days.indexOf(n) !== -1; });
      if (!ok.some(Boolean)) return;
      var tz = /^[+-]\d{4}$/.test(el.dataset.tzOffset || '') ? el.dataset.tzOffset : '+0000';
      var offMs = (tz.charAt(0) === '-' ? -1 : 1) * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10)) * 60000;
      var text = el.dataset.text || 'Order in the next {time} to ship today';
      var after = el.dataset.after || 'Orders placed now ship {day}';
      var units = (el.dataset.units || 'h,m,s').split(',').map(function (u) { return u.trim(); });
      var longNames = (el.dataset.dayNames || 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday').split(',').map(function (n) { return n.trim(); });
      var tomorrowWord = el.dataset.tomorrow || 'tomorrow';
      var out = $('[data-ed-ship-text]', el) || el;
      var esc = function (str) { return String(str).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      function tick() {
        var now = Date.now();
        var local = new Date(now + offMs);
        var dow = local.getUTCDay();
        var todayCut = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), H, M, 0) - offMs;
        if (ok[dow] && todayCut > now) {
          var left = Math.floor((todayCut - now) / 1000);
          var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
          var t = (h > 0 ? h + (units[0] || 'h') + ' ' : '') + (h > 0 ? pad(m) : m) + (units[1] || 'm') + ' ' + pad(s) + (units[2] || 's');
          out.innerHTML = esc(text).split('{time}').join('<b class="ed-ship__time">' + t + '</b>');
        } else {
          var k = 1;
          while (k < 7 && !ok[(dow + k) % 7]) k++;
          var dayName = k === 1 ? tomorrowWord : (longNames[(dow + k) % 7] || '');
          out.textContent = after.split('{day}').join(dayName);
        }
        el.hidden = false;
      }
      var iv = setInterval(function () { if (!el.isConnected) { clearInterval(iv); return; } tick(); }, 1000);
      tick();
    });
  }

  /* Cart drawer redraws its contents after every cart change: start clocks in the new markup */
  function watchCartDrawer() {
    if (window.__edDrawerWatch || !window.MutationObserver) return;
    window.__edDrawerWatch = true;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; initShipTimers(); });
    }).observe(document.body, { childList: true, subtree: true });
    /* One-click upsell feedback */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ed-upsell-add]');
      if (!btn) return;
      var label = btn.querySelector('span');
      if (label && btn.dataset.adding) label.textContent = btn.dataset.adding;
      btn.setAttribute('aria-busy', 'true');
    }, true);
  }

  function init() {
    initAnnouncements(); initHeader(); initCarousels(); initTabs(); initSwitchers(); initProduct(); initLotSearch(); initVideos(); initSort(); initBlogFilter(); initReviews(); initReviewSummary(); initCountdowns(); initShipTimers(); watchCartDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Re-init inside the theme editor when sections re-render */
  document.addEventListener('shopify:section:load', function () { init(); });
})();
